<template>
  <div id="meus-clientes">
    <my-tour
      v-if="checkContent && itens.length > 0 || semItem"
      :steps="steps"
      name="steps-gerenciamento-lead"
    />

    <section id="content">

      <!--start container-->
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l12">
            <TituloPagina class="header" titulo="Gerenciamento de Leads"/>
            <div class>
              <div class="row">
                <!--Inicio Lista-->
                <div class="col s12 m10 l10 ">
                  <div class="row">
                    <div class="col s12 m12 l12">
                      <div style="100%">
                        <div
                          class="pb-1 pt-1"
                          style="display: flex;justify-content: flex-end;align-items: center;"
                        >
                          <button
                            class="btn waves-effect waves-light right green remover"
                            v-bind:disabled="checkedItems.length <= 0"
                            @click="efetivarAllChecked()"
                            v-if="checkCargoFuncionario([cargoDono, cargoGerente, cargoEspecialista], [cargoDono, cargoGerente, cargoEspecialista])"
                          >
                            <i class="material-icons left">thumb_up</i>
                            Efetivar
                          </button>

                          <button
                            class="btn waves-effect waves-light right red remover ml-2"
                            v-bind:disabled="checkedItems.length <= 0"
                            @click="removeAllChecked()"
                            v-if="checkCargoFuncionario([cargoDono, cargoGerente, cargoEspecialista], [cargoDono, cargoGerente, cargoEspecialista])"
                          >
                            <i class="material-icons left">close</i>
                            Remover
                          </button>

                          <div id="export-file" class="pl-2 hide-on-med-and-down">
                            <button
                              class="btn waves-effect waves-light right btn-default"
                              @click="exportarPdf">
                              <i class="material-icons left">file_download</i>
                              Exportar PDF
                            </button>
                          </div>

                          <div id="export-file" class="pl-2 hide-on-med-and-down">
                            <button
                              class="btn waves-effect waves-light right btn-default"
                              @click="exportarCsv">
                              <i class="material-icons left">file_download</i>
                              Exportar CSV
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="isloadingPdf" class="col s12" style="text-align: center; margin-top: 3rem;">
                        <h6>Gerando PDF...</h6>
                        <pulse-loader :loading="loading" :color="blue" :size="size"></pulse-loader>
                    </div>

                    <div v-if="isloadingCsv" class="col s12" style="text-align: center; margin-top: 3rem;">
                        <h6>Gerando CSV...</h6>
                        <pulse-loader :loading="loading" :color="blue" :size="size"></pulse-loader>
                    </div>
                  </div>


                <pagination-info v-model="itens" />

                  <ContainerAlert :show="!checkContent" message="Carregando Leads..."/>
                  <ContainerAlert
                    :show="checkContent && itens.length === 0"
                    message="Nenhum Lead cadastrado..."
                  />


                <lead-card
                  :id="`lead-card-${index}`"
                  :status-class="getClassEstado(item.pedido_historico.pedido_estagio_id)"
                  v-for="(item, index) in paginationConfig.itens"
                  :key="`lead-card-${item.pedido_id}`">

                    <div
                      slot="status"
                      class="card-lead-status"
                      :class="item.cliente_has_produto.produto_id != 0 && getClassEstado(item.pedido_historico.pedido_estagio_id)">
                      <div v-if="item.cliente_has_produto.produto_id != 0">
                        {{ item.pedido_historico.pedido_estagio.pedido_estagio_nome }}
                      </div>
                    </div>

                    <template v-slot:actions>
                        <span :id="`lead-selecionar-${index}`">
                          <input
                            type="checkbox"
                            :id="item.pedido_id"
                            :value="item.pedido_id"
                            v-model="checkedItems"
                            v-bind:disabled="checkTotalChecked(item.pedido_id)"
                            :onchange="checkedItem()"
                            v-if="checkCargoFuncionario([cargoDono, cargoGerente, cargoEspecialista], [cargoDono, cargoGerente, cargoEspecialista])">
                          <label :for="item.pedido_id"></label>
                        </span>

                        <router-link
                            class="text-default mr-1"
                            v-tooltip.bottom="'Editar'"
                            :to="`/cliente/${item.cliente_has_produto.cliente_id}`"
                        >
                            <i class="material-icons">mode_edit</i>
                        </router-link>

                        <botao-remover
                          :identificador="item.pedido_id"
                          :url="'pedido/'+item.pedido_id"
                          :id="`lead-btn-remover-${index}`"
                          v-if="checkCargoFuncionario([cargoDono, cargoGerente, cargoEspecialista], [cargoDono, cargoGerente, cargoEspecialista])"
                          @deleted="() => paginationConfig.itens.splice(index, 1)"
                        />

                        <div class="right-align width-100">
                            <small class=" grey-text">{{ item.data_criacao | formatDate }}</small>
                        </div>
                    </template>

                    <lead-card-item :id="`lead-cliente-${index}`" specialTitle :title="item.cliente_has_produto.cliente.pessoa.pessoa_nome"></lead-card-item>

                    <lead-card-item title="NECESSIDADE DO SEGURADO" v-if="simuladorStatus > 0">
                      <span class="text-default">{{ item.cliente_has_produto.cliente.resumo_necessidades.necessidade_segurado | dinheiro }}</span>
                    </lead-card-item>

                    <lead-card-item title="ID" :id="`lead-responsavel-${index}`">
                        <span class="text-default"> {{ item.pedido_id ? item.pedido_id : '' }}</span>
                    </lead-card-item>

                    <lead-card-item title="PRODUTO" :id="`lead-produto-${index}`">
                      <span v-if="item.cliente_has_produto.produto_id == 0" class="text-default">
                        Simulando...
                      </span>
                      <span v-else class="text-default">
                        {{ item.cliente_has_produto.produto.produto_nome }}
                      </span>
                    </lead-card-item>

                    <lead-card-item title="RESPONSÁVEL" :id="`lead-responsavel-${index}`">
                     <span class="text-default"> {{ item.pedido_historico.funcionario ? item.pedido_historico.funcionario.pessoa.pessoa_nome : '-' }}</span>
                    </lead-card-item>
                    <lead-card-item title="AUTOR" :id="`lead-autor-${index}`">
                      <span class="text-default"> {{ item.funcionario ? item.funcionario.pessoa.pessoa_nome : '[SITE]' }}</span>
                    </lead-card-item>

                    <lead-card-item>
                          <div class="flex-row center-xs">
                            <div class="col-xs">
                                <div class="input-field">
                                  <router-link class="btn btn-block btn-default waves-light" :to="{name: paginaEdicaoLead, params: {pedidoId: item.pedido_id}}">PERFIL</router-link>
                                </div>
                                <div class="input-field">
                                  <button class="btn btn-block btn-default waves-light" @click="duplicarLead(item.cliente_has_produto.cliente)">DUPLICAR</button>
                                </div>
                            </div>
                            <div class="col-xs" v-if="simuladorStatus > 0">
                                <div class="input-field">
                                  <router-link class="btn btn-block btn-default waves-light"
                                      :to="{name: 'cliente_simulador', params: {id: item.cliente_has_produto.cliente_id}}">
                                    <span>SIMULAR</span>
                                    <span class="btn-icon-circle" :class="{'active' : usouSimulador(item.cliente_has_produto.cliente)}"></span>
                                  </router-link>
                                </div>
                            </div>
                          </div>
                    </lead-card-item>

                </lead-card>

                  <Pagination
                    v-if="itens.last_page > 1"
                    :perPage="paginationConfig.perPage"
                    :qty="paginationConfig.qty"
                    :setCurrent="setCurrent"
                    :current="paginationConfig.current"
                  />

                </div>
                <!--Fim Lista-->
                <!--Início Card-->
                <div class="col s12 m4 l2 p2">
                  <card
                    title="Filtros"
                    :showActions="showCardActionsFilter"
                    @clearFilter="limparFiltros">
                    <template slot="content">
                      <div class="row">
                        <div class="col s12">

                          <filtro-por-lead
                            @change="manipulaFiltrosPorLead"
                            @removeSelecionados="manipulaLeadsSelecionados"
                            :leads="filtros.leads"
                            :leadsSelecionados="leads.selected"
                          />

                          <filtro-por-responsaveis
                            @change="manipulaFiltroPorResponsavel"
                            @removeSelecionado="manipulaResponsaveisSelecionados"
                            :responsaveis="filtros.responsaveis"
                          />

                          <filtro-por-autores
                            @removeSelecionado="manipulaAutoresSelecionados"
                            @change="manipulaFiltroPorAutores"
                            :autores="filtros.autores"
                            v-if="[1, 2].includes(usuarioLogadoCargo)"
                          />

                          <filtro-por-data
                            @inputData="manipulaFiltroPorData"
                            :data_ini="filtros.data_ini"
                            :data_fim="filtros.data_fim"
                          />

                          <filtro-por-plataforma-origem
                            @change="manipulaFiltroPorPlataformaOrigem"
                            :plataformaOrigem="filtros.plataformaOrigem"
                            v-if="!isUsuarioSegasp"
                          />
                          <filtro-por-estados
                            title="Por Estado:"
                            @change="mainputaFiltroPorEstado"
                            :estados="filtros.estados"
                          />

                          <filtro-por-categorias
                            title="Por Categorias"
                            @change="manipulaFiltroPorCategoria"
                            :categorias="filtros.categorias"
                          />

                          <filtro-por-produtos
                            title="Por Produtos"
                            @change="manipulaFiltroPorProduto"
                            :produtos="filtros.produtos"
                          />
                        </div>
                      </div>
                    </template>
                  </card>
                </div>
              </div>
              <!--Fim Card-->
            </div>
          </div>
        </div>
        <div class="fixed-action-btn">
          <router-link to="/cliente/cadastro" id="add-lead" class="btn-floating btn-large btn-default">
            <i class="large material-icons">add</i>
          </router-link>
        </div>
      </div>
    </section>


    <modal-duplicar-lead
        :formDataDuplicarLead="formDataDuplicarLead"
        :modalDuplicarLead="modalDuplicarLead"
        @close="modalDuplicarLead = false"
    />

  </div>
</template>

<script>

/* IMPORTS */
import Auth from "@/store/auth";
import { isMultiEmpresa } from "@/environment";

import swal from "sweetalert2";
import { debounce, isEqual } from "lodash";

//*common functions
import { api } from "@/helpers/api";
import ConverterHelper from "@/helpers/converter";
import TourHelper from "@/helpers/tour";
import { checaCargo } from "@/helpers/perfil";
import Message from "@/helpers/message";
import ListHelper from "@/helpers/list";
import { formataDataEnUS, formataDataPtBr, validaData} from "@/helpers/validates";
import LeadCard from '../common/LeadCard.vue';
import LeadCardItem from '../common/LeadCardItem.vue';

//*constants
import {
  DONO,
  GERENTE,
  CORRETOR,
  ESPECIALISTA,
  LIDER,
  MASTER,
  PARCEIRO
} from "@/constants/funcionarioCargo.js";

//* components
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'

import BotaoRemover from "@/components/common/BotaoRemover";
import Card from "@/components/common/Card/Card";
import ContainerAlert from "@/components/common/ContainerAlert/ContainerAlert";
import Datepicker from "vuejs-datepicker";
import FiltroPorData from "./listagem/FiltroPorData";
import FiltroPorEstados from "./listagem/FiltroPorEstados";
import FiltroPorLead from "./listagem/FiltroPorLead";
import FiltroPorProdutos from "./listagem/FiltroPorProduto";
import FiltroPorCategorias from "./listagem/FiltroPorCategoria";
import FiltroPorResponsaveis from "./listagem/FiltroPorResponsaveis";
import FiltroPorAutores from "./listagem/FiltroPorAutores";
import FiltroPorPlataformaOrigem from "./listagem/FiltroPorPlataformaOrigem";
import MaskedInput from "vue-masked-input";
import MyTour from "@/components/common/MyTour.vue";
import Modal from '@/components/common/Modal/Base.vue';
import ModalDuplicarLead from "@/components/lead/ModalDuplicarLead";

import Pagination from "@/components/common/Pagination/Pagination";
import PaginationInfo from "@/components/common/Pagination/PaginationInfo"
import TituloPagina from "@/components/common/TituloPagina";

import "@/../static/assets/css/custom/flex.css";

/* EXPORTS */
export default {
  filters: {

    formatFirstLetter(value) {

        let nomes = value.split(" ");

        let first_name = nomes.shift();

        return `<span class="client-name"><strong class="first-name">${first_name}</strong> ${nomes.join(' ')}</span>`;
    }
  },

  components: {
    BotaoRemover,
    Card,
    ContainerAlert,
    Datepicker,
    FiltroPorAutores,
    FiltroPorData,
    FiltroPorEstados,
    FiltroPorLead,
    FiltroPorProdutos,
    FiltroPorCategorias,
    FiltroPorResponsaveis,
    FiltroPorPlataformaOrigem,
    MaskedInput,
    MyTour,
    Pagination,
    PaginationInfo,
    TituloPagina,
    LeadCard,
    LeadCardItem,
    Modal,
    PulseLoader,
    ModalDuplicarLead,
  },

  computed: {
    paginaEdicaoLead() {
      return this.simuladorStatus == 2 ? 'gerenciamentoLeadSimulador' : 'gerenciamentoLead';
    },

    isUsuarioSegasp() {
        return Auth.getEmpresaId() === 1;
    }
  },

  data () {
    return {
      simuladorStatus: 0,

      paginationConfig: {
        perPage: 20,
        qty: 1,
        current: 1,
        itens: []
      },

      itens: {data: []},

      leads: {
        itens: [],
        typed: null,
        selecteds: []
      },

      filtros: {
        data_ini: "",
        data_fim: "",
        estados: [],
        categorias: [],
        produtos: [],
        leads: [],
        responsaveis: [],
        autores: [],
        plataformaOrigem: '',
      },

      checkedItems: [],
      showCardActionsFilter: true,
      checkContent: false,
      cargoDono: null,
      cargoGerente: null,
      cargoCorretor: null,
      cargoEspecialista: null,
      cargoParceiro: null,
      cargoMaster: null,
      usuarioLogadoCargo: null,
      multiempresa: false,
      semItem: false,
      steps: [
        {
          parent: "#lead-cliente-0",
          target: "#lead-cliente-0",
          content: "Nome do Lead cadastrado",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            // placement: 'left',
            menu: false
          }
        },
        {
          parent: "#lead-produto-0",
          target: "#lead-produto-0",
          content: "Produto que o Lead tem interesse",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            // placement: 'left',
            menu: false
          }
        },
        {
          parent: "#lead-card-0",
          target: ".card-lead-status",
          content: "Fase atual em que o Lead se encontra",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            // placement: 'left',
            menu: false
          }
        },
        {
          parent: "#lead-responsavel-0",
          target: "#lead-responsavel-0",
          content: "Consultor responsável pelo Lead",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            // placement: 'left',
            menu: false
          }
        },
        {
          parent: "#lead-autor-0",
          target: "#lead-autor-0",
          content: "Perfil que cadastrou o Lead",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            // placement: 'left',
            menu: false
          }
        },
        {
          parent: "#lead-btn-remover-0",
          target: "#lead-btn-remover-0",
          content: "Podemos exclui-lo por aqui",
          params: {
            cargos: [DONO, GERENTE, ESPECIALISTA],
            placement: "right",
            menu: false
          }
        },
        {
          parent: "#lead-selecionar-0",
          target: "#lead-selecionar-0",
          content: "ou selecionar vários",
          params: {
            cargos: [DONO, GERENTE, ESPECIALISTA],
            placement: "right",
            menu: false
          }
        },
        {
          parent: ".remover",
          target: ".remover",
          content: "e clicar aqui!",
          params: {
            cargos: [DONO, GERENTE, ESPECIALISTA],
            // placement: 'left',
            menu: false
          }
        },
        {
          parent: "#filter1",
          target: "#filter1",
          content:
            "Se quiser encontrar um lead especifico, basta digitar o nome e selecioná-lo! Obs: Se após filtrar não tiver registros, ele pode ser encontrado na seção de <b>Leads removidos</b> no Menu",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            placement: "left",
            menu: false
          }
        },
        {
          parent: "#filter-1",
          target: "#filter-1",
          content:
            "Se quiser encontrar um responsável especifico, basta digitar fazer o mesmo dito anteriormente!",
          params: { cargos: [DONO, GERENTE, ESPECIALISTA], placement: "left", menu: false }
        },
        {
          parent: "#filter0",
          target: "#filter0",
          content: "Se quiser encontrar um autor, da mesma forma!",
          params: { cargos: [DONO, GERENTE, ESPECIALISTA], placement: "left", menu: false }
        },
        {
          parent: "#filter2",
          target: "#filter2",
          content:
            "Se quiser ver os Leads que foram criados em um periodo especifico de datas, utilize este filtro!",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            placement: "left",
            menu: false
          }
        },
        {
          parent: "#filter3",
          target: "#filter3",
          content:
            "Se quiser filtrar por estados também é possivel! Basta marcar o campo correspondente ao que deseja!",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            placement: "left",
            menu: false
          }
        },
        {
          parent: "#filter4",
          target: "#filter4",
          content: "Mesma coisa acontece para filtrar por produtos!",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            placement: "left",
            menu: false
          }
        },
        {
          parent: "#export-file",
          target: "#export-file",
          content:
            "Clicando aqui é possivel exportar a listagem completa, ou quando o filtro tiver marcado exportar de maneira filtrada!",
          params: {
            cargos: [DONO, GERENTE, ESPECIALISTA],
            placement: "left",
            menu: false
          }
        },
        {
          parent: ".colNomeCliente:eq(0)",
          target: ".colNomeCliente",
          content:
            "Para detalhes do Lead e seu histórico, basta clicar sobre ele!",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            placement: "bottom",
            menu: false,
            route: "/lead-gerenciamento/1230",
            table: {
              enable: true,
              target: ".colNomeCliente"
            }
          }
        },
        {
          parent: "",
          target: "",
          content: "",
          params: {
            cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
            placement: "left",
            menu: false
            // route: '/gerenciamento-leads'
          }
        }
      ],

      modalDuplicarLead: false,

      produtosItens: [],

      formDataDuplicarLead: {
        empresa_indicada_id: 1,
        cliente_id: null,
        produto_id: null,
        pedido_estagio_id: 1,
        plataforma_origem: 1,
      },

      isloadingPdf: false,
      isloadingCsv: false,

    };
  },

  created() {

    api.get('simulador-habilitado').then(({data: {result: {data}}}) => {
      this.simuladorStatus = data.status;
    })


    this.multiempresa = isMultiEmpresa;
    this.usuarioLogadoCargo = Auth.getCargoUsuario();
    this.cargoDono = DONO;
    this.cargoGerente = GERENTE;
    this.cargoCorretor = CORRETOR;
    this.cargoEspecialista = ESPECIALISTA;
    this.cargoParceiro = PARCEIRO;
    this.cargoMaster = MASTER;
    const self = this;

    if (this.$route.query) {

      let filtros = {
        ...this.filtros,
        ...this.$route.query
      };

      ['responsaveis', 'estados', 'produtos', 'autores', 'leads'].forEach(key => {
        filtros[key] = this.forcarArray(filtros[key])
      })

      this.filtros = filtros;
    }

    this.getItens();
  },

    watch: {
        filtros: {
            deep: true,
            handler(filtros) {
                this.$router.replace({ query: {...filtros} });
                this.getItens();
            }
        },

        "paginationConfig.current"(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getItens();
            }
        },

        "filtros.estados"() {
            this.paginationConfig.current = 1;
            this.getItens();
        },

        "filtros.produtos"() {
            this.paginationConfig.current = 1;
            this.getItens();
        },

        "filtros.responsaveis"() {
            this.paginationConfig.current = 1;
            this.getItens();
        },

        "filtros.autores"() {
            this.paginationConfig.current = 1;
            this.getItens();
        },

        "filtros.plataformaOrigem"() {
            this.paginationConfig.current = 1;
            this.getItens();
        },

        "filtros.leads"() {
            this.paginationConfig.current = 1;
            this.getItens();
        },
    },

    methods: {
        async exportarPdf()
        {
            this.isloadingPdf = true;

            const params = {
                page_qtd: this.paginationConfig.perPage,
                page: this.paginationConfig.current,
                ...this.prepareParams(),
                tipo: 'pdf',
                pedidos: this.checkedItems.join(','),
            };

            const {data: blob}  = await api.post('pedido/meus-pedidos', params, {
                responseType: 'blob'
            });


            const a = document.createElement('a');

            a.href = URL.createObjectURL(blob);

            a.download = 'relatorio-leads.pdf';

            a.click();

            this.isloadingPdf = false;
        },

        async exportarCsv()
        {
            this.isloadingCsv = true;

            const params = {
                page_qtd: this.paginationConfig.perPage,
                page: this.paginationConfig.current,
                ...this.prepareParams(),
                tipo: 'csv',
                pedidos: this.checkedItems.join(','),
            };

            const { data: blob }  = await api.post('pedido/meus-pedidos', params, {
                responseType: 'blob'
            });

            const a = document.createElement('a');

            a.href = URL.createObjectURL(blob);

            a.download = 'relatorio-leads.csv';

            a.click();

            this.isloadingCsv = false;
        },

        usouSimulador(cliente) {

            const keys = [
                'informacao_adicional',
                'educacao_filhos',
                'independencia_financeira',
                'fontes_renda',
                'seguros',
                'padrao_vida',
                'patrimonio',
                'projeto',
                'obrigacao_financeira',
                'quantidade_questionario_investidor_resposta'
            ];

            return keys.some(key => {

                return cliente[key] instanceof Array
                    ? cliente[key].length > 0
                    : !!cliente[key];
            });
        },
        mainputaFiltroPorEstado(value) {
            Object.assign(this.filtros, {
                estados: value
            });
        },

        manipulaFiltroPorCategoria(value) {

            Object.assign(this.filtros, {
                categorias: value
            });
        },

        manipulaFiltroPorProduto(value) {

            Object.assign(this.filtros, {
                produtos: value
            });
        },

        manipulaFiltroPorData(value) {

            Object.assign(this.filtros, {
                data_ini: value.data_ini,
                data_fim: value.data_fim
            });
        },

        manipulaFiltroPorResponsavel(value) {

            Object.assign(this.filtros, {
                responsaveis: value.responsaveis
            });
        },

        manipulaResponsaveisSelecionados(value) {

            const eResponsaveis = value.responsaveis;
            const { respSelecionados } = value;
            let { responsaveis } = this.filtros

            Object.assign(this.filtros, {
                responsaveis: !isEqual(responsaveis, eResponsaveis)
                    ? eResponsaveis
                    : responsaveis
            });
        },

        manipulaFiltroPorAutores(value) {

            Object.assign(this.filtros, {
                autores: value.autores
            });
        },

        manipulaFiltroPorPlataformaOrigem(value) {
            Object.assign(this.filtros, {
                plataformaOrigem: value.plataformaOrigem
            });
        },

        manipulaAutoresSelecionados(value) {
        const eAutores = value.autores;
        const { autoersSelecionados } = value;
        let { autores } = this.filtros;

        Object.assign(this.filtros, {
            autores: !isEqual(autores, eAutores)
                ? eAutores
                : autores
        });
        },

        manipulaFiltrosPorLead(value) {

            Object.assign(this.filtros, {
                leads: value.leads
            });

            Object.assign(this.leads, {
                selected: value.leadsSelecionados
            });
        },

        manipulaLeadsSelecionados(value) {
            const eLeads = value.leads;
            const { leadsSelecionados } = value;
            let { leads } = this.filtros;

            Object.assign(this.filtros, {
                leads: !isEqual(leads, eLeads)
                    ? eLeads
                    : leads
            });

            Object.assign(this.leads, {
                selected: value.leadsSelecionados
            });

        },

        forcarArray(items) {
            return items instanceof Array
                ? items
                : [items]
        },

        debounceLead: debounce(function(e) {
            let time;
            clearTimeout(time);
            const self = this;

            time = setTimeout(function() {
                self.leads.typed = e.target.value;
            }, 3000);

        }, 200),

        getClassEstado(pedido_estagio_id) {
            return ConverterHelper.getCoresEsteira(pedido_estagio_id);
        },

        removeFilterLead(id) {
            this.leads.selecteds = this.leads.selecteds.filter(check => check != id);
            this.filtros.leads = this.filtros.leads.filter(item => item != id);
        },

        removeAutorFilter(id) {
            this.autores.selecteds = this.autores.selecteds.filter(
                check => check != id
            );

            this.filtros.autores = this.filtros.autores.filter(item => item != id);
        },

        limparFiltros(e) {
            this.filtros.data_ini = "";
            this.filtros.data_fim = "";
            this.filtros.estados = [];
            this.filtros.responsaveis = [];
            this.filtros.autores = [];
            this.filtros.categorias = [];
            this.filtros.produtos = [];
            this.filtros.leads = [];
            this.filtros.plataformaOrigem = '';

            this.leads.itens = [];
            this.leads.selected = [];
            this.responsaveis.itens = [];
            this.autores.itens = [];

            this.leads.typed = "";
            this.responsaveis.typed = "";
            this.autores.typed = "";

            $("#lead-input").val("");
            $("#responsavel-input").val("");
            $("#autor-input").val("");

        },

        setCurrent(current) {
            this.paginationConfig.current = current;
        },

        checkCargoFuncionario(cargoMono, cargoMulti) {
            return checaCargo(cargoMono, cargoMulti);
        },
        checkTotalChecked(id) {
            return (
                this.checkedItems.indexOf(id) === -1 && this.checkedItems.length >= 5
            );
        },
        checkedItem() {
            if (this.checkedItems.length >= 5) {
                swal("Selecione no máximo 5 LEADS.", "", "info");
            }
        },

        removeSelected() {
            return new Promise(resolve => {
                this.checkedItems.forEach(data => {
                    api.delete("pedido/" + data).then(function(response) {});
                });

                resolve();
            });
        },

        showLoading() {
            this.$parent.$emit("showLoading", true);
        },

        hideLoading() {
            this.$parent.$emit("showLoading", false);
        },

        efetivarSelected() {
            return new Promise(resolve => {
                this.checkedItems.forEach(data => {
                    api.post('processo/efetivar', {
                        pedido_id: data,
                        pedido_efetivado_observacao: 'Efetivado em massa',
                    }).then(function(response) {});
                });

                resolve();
            });
        },

        efetivarAllChecked() {
            swal({
                title: "Tem certeza que deseja efetivar?",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#81C784",
                confirmButtonText: "Sim!",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            }).then(result => {
                if (!result.value) return;

                this.showLoading();

                this.efetivarSelected().then(() => {
                    this.hideLoading();
                    swal("Efetivados!", "", "success").then(() => {
                        location.reload();
                    });
                });
            });
        },

        removeAllChecked() {
            let self = this;
            swal({
                title: "Tem certeza que deseja excluir?",
                text: "Você não terá mais acesso a esse registro!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim!",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            }).then(result => {
                if (result.value) {
                    self.showLoading();
                    self.removeSelected().then(() => {
                            self.hideLoading();
                            swal("Deletados!", "", "success").then(() => {
                            location.reload();
                        });
                    });
                }
            });
        },

        convertToParams(itens) {
            return itens.join();
        },

        prepareParams() {

            const query = this.filtros;

            let params = {
                page_qtd: this.paginationConfig.perPage,
                page: this.paginationConfig.current
            };

            if (query.estados instanceof Array) {

                if (Array.isArray(query.estados)) {
                    params.estados = this.convertToParams(query.estados);
                }

                // const newEstados = [];
                // newEstados.push(query.estados);
                // params.estados = this.convertToParams(newEstados);
            }

            if (query.categorias instanceof Array) {
                if (Array.isArray(query.categorias)) {
                    params.categorias = this.convertToParams(query.categorias);
                }
            }

            if (query.produtos instanceof Array) {
                if (Array.isArray(query.produtos)) {
                    params.produtos = this.convertToParams(query.produtos);
                }

                // const newProdutos = [];
                // newProdutos.push(query.produtos);
                // params.produtos = this.convertToParams(newProdutos);
            }

            if (validaData(query.data_ini) && validaData(query.data_fim)) {
                params.data_ini = formataDataEnUS(query.data_ini);
                params.data_fim = formataDataEnUS(query.data_fim);
            }

            if (query.responsaveis) {
                query.responsaveis instanceof Array
                    ? params.responsaveis = this.convertToParams(query.responsaveis)
                    : params.responsaveis = this.convertToParams([query.responsaveis]);
            }

            if (query.autores) {
                query.autores instanceof Array
                    ? params.autores = this.convertToParams(query.autores)
                    : params.autores = this.convertToParams([query.autores]);
            }

            if (query.leads) {
                query.leads instanceof Array
                    ? params.leads = this.convertToParams(query.leads)
                    : params.leads = this.convertToParams([query.leads]);
            }

            if (query.plataformaOrigem) {
                params.plataforma_origem = query.plataformaOrigem;
            }

            return params;
        },

        async prepareItens(data) {

            const itens = data.data;

            this.itens = data;

            this.semItem = itens.length == 0;

            this.paginationConfig.qty = data.total;

            this.paginationConfig.itens = itens;

            this.hideLoading();

            this.checkContent = true;

            if (this.semItem) {

                this.steps = [
                    {
                    parent: "#filter1",
                    target: "#filter1",
                    content:
                        "Se quiser encontrar um lead especifico, basta digitar o nome e selecioná-lo! Obs: Se após filtrar não tiver registros, ele pode ser encontrado na seção de <b>Leads removidos</b> no Menu",
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
                        placement: "left",
                        menu: false
                    }
                    },
                    {
                    parent: "#filter-1",
                    target: "#filter-1",
                    content:
                        "Se quiser encontrar um responsável especifico, basta digitar fazer o mesmo dito anteriormente!",
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA], placement: "left", menu: false }
                    },
                    {
                    parent: "#filter0",
                    target: "#filter0",
                    content: "Se quiser encontrar um autor, da mesma forma!",
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA], placement: "left", menu: false }
                    },
                    {
                    parent: "#filter2",
                    target: "#filter2",
                    content:
                        "Se quiser ver os Leads que foram criados em um periodo especifico de datas, utilize este filtro!",
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
                        placement: "left",
                        menu: false
                    }
                    },
                    {
                    parent: "#filter3",
                    target: "#filter3",
                    content:
                        "Se quiser filtrar por estados também é possivel! Basta marcar o campo correspondente ao que deseja!",
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
                        placement: "left",
                        menu: false
                    }
                    },
                    {
                    parent: "#filter4",
                    target: "#filter4",
                    content: "Mesma coisa acontece para filtrar por produtos!",
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
                        placement: "left",
                        menu: false
                    }
                    },

                    {
                    parent: "#left-sidebar-nav",
                    target: "#removidos",
                    content:
                        "Para vermos os Leads que foram excluídos, basta no menu clicar em <b>Leads removidos</b>!",
                    params: {
                        cargos: isMultiEmpresa ? [DONO, GERENTE, ESPECIALISTA] : [DONO],
                        placement: "left",
                        menu: true,
                        route: "/gerenciamento-leads-removidos"
                    }
                    },
                    {
                    parent: "#left-sidebar-nav",
                    target: "#cadastro-cliente",
                    content:
                        "Para cadastrar um lead, basta no menu Cliente clicar em <b>Cadastro</b>!",
                    params: {
                        cargos: isMultiEmpresa
                        ? [PARCEIRO]
                        : [GERENTE, ESPECIALISTA, CORRETOR, LIDER, PARCEIRO],
                        placement: "left",
                        menu: true,
                        route: "/cliente/cadastro",
                        subMenu: true,
                        subMenuTarget: "#group-cliente"
                    }
                    },

                    {
                    parent: "",
                    target: "",
                    content: "",
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA, CORRETOR, LIDER],
                        placement: "left",
                        menu: false
                    }
                    }
                ];
            }

            this.steps = TourHelper.createSteps(this.steps);
        },

        getItens(options) {

            this.showLoading()


            const params = {
                page_qtd: this.paginationConfig.perPage,
                page: this.paginationConfig.current,
                ...this.prepareParams()

            };
            api.post("pedido/meus-pedidos", params)
            .then(response => {
                const { data } = response.data.result;
                return this.prepareItens(data);

            });
        },

        duplicarLead(cliente) {
            this.formDataDuplicarLead = {
                empresa_indicada_id: 1,
                cliente_id: cliente.cliente_id,
                produto_id: null,
                pedido_estagio_id: 1,
                plataforma_origem: 1,
            };

            this.modalDuplicarLead = true;
        }
    }
};
</script>

<style>

.text-orange{
    color: orange;
}

.contact-featured {
  padding: 3px 4px !important;
}
.rowCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
#meus-clientes table {
  text-transform: uppercase;
}

#meus-clientes table {
  width: 100%;
}

#meus-clientes thead,
#meus-clientes tbody,
#meus-clientes tr,
#meus-clientes td,
#meus-clientes th {
  display: block;
}

#meus-clientes tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}

#meus-clientes thead th {
  height: 30px;
  text-align: left;
}

#meus-clientes tbody {
  position: relative;
  min-height: 755px;
  overflow-y: auto;
}

#meus-clientes thead {
  /* fallback */
}

#meus-clientes tbody td,
#meus-clientes thead th {
  float: left;
}

#meus-clientes .colId {
  width: 5%;
}

#meus-clientes .colNome {
  width: 25%;
}

#meus-clientes .colProduto {
  width: 15%;
}

#meus-clientes .colFranquia {
  width: 13%;
}
#meus-clientes .colEstado {
  width: 12%;
}

#meus-clientes .colResponsavel {
  width: 17%;
}

#meus-clientes .colAutor-sm {
  width: 15%;
}
#meus-clientes .colAutor-lg {
  width: 31%;
}

#meus-clientes .colAcao {
  width: 10%;
}


@media screen and (max-width: 768px) {
  #meus-clientes .colId {
    width: 20%;
  }

  #meus-clientes .colNome {
    width: 60%;
  }

  #meus-clientes .colProduto {
    display: none;
  }

  #meus-clientes .colEstado {
    display: none;
  }

  #meus-clientes .colResponsavel {
    display: none;
  }

  #meus-clientes .colAutor {
    display: none;
  }

  #meus-clientes .colAcao {
    width: 20%;
  }
}
@media (max-width: 700px) and (orientation: landscape) {
  #meus-clientes .colAutor {
    display: initial;
  }
  #meus-clientes .colNome {
    width: 50%;
  }
  #meus-clientes .colAcao {
    width: 10%;
  }
}



.client-name{
  color: #222;
  text-transform: uppercase;
  word-break: break-all;

}

.client-name .first-name{
  font-size: 28px;
  display: block;
}




[type="checkbox"]:checked + label:before{
    border-right-color: #44a3ac;
    border-bottom-color: #44a3ac;
}


@keyframes pulse{
    to{
        box-shadow: 0 0 0 15px rgba(#fff, .15);
    }
}


</style>

<style lang="scss" scoped>
@import '@/assets/sass/card-lead.scss';
@import "@/assets/sass/crm.scss";


.btn-block{
  width: 100%;
}


.btn-default{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;

    .btn-icon-circle{
        margin-left: 5px;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background-color: #fff;
        animation: pulse 1s ease infinite;
        display: block;

        &.active{
            background-color: orange;
            animation: none;
        }
    }
}


</style>

<style lang="scss">
@import '@/assets/sass/card-lead.scss';
</style>



// WEBPACK FOOTER //
// src/components/lead/Listagem.vue